<template>
  <div class="customer-point">
    <h3 class="page-title2">服务网点维护</h3>
    <el-button class="btn" @click="handleOpenDialog()">新增服务网点</el-button>
    <el-form :inline="true" style="margin-top: 10px">
      <el-form-item label="网点类型">
        <el-select class="item-input" v-model="Search.PosType" placeholder="在行无人银行/离行无人银行/网点营业厅" style="width: 300px" clearable>
          <el-option label="在行无人银行" :value="1"></el-option>
          <el-option label="离行无人银行" :value="2"></el-option>
          <el-option label="网点营业厅" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-select class="item-input" v-model="Search.PosDeviceType" placeholder="现金自助设备/非现金自助设备" style="width: 250px" clearable>
          <el-option label="现金自助设备" :value="1"></el-option>
          <el-option label="非现金自助设备" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="网点编号">
        <el-input v-model="Search.Code" class="item-input" placeholder="请输入网点编号" style="width: 160px"></el-input>
      </el-form-item>
      <el-form-item label="地区">
        <el-cascader style="width: 160px" v-model="Search.Place" :options="Provinces" @active-item-change="handleItemChange" :props="{value: 'Id', label: 'Name', children: 'children'}" placeholder="请选择地区（省/市）" clearable></el-cascader>
      </el-form-item>
      <el-form-item label="机器编码">
        <el-input v-model="Search.AtmCode" class="item-input" placeholder="请输入机器编码" style="width: 160px" @click.native="getPoint"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width: 120px;" @click="getPoint">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="Points" v-loading.body="loading">
      <el-table-column type="expand">
        <template scope="props">
          <span style="color: #7f8fa4;">ATM机数量：</span>
          <span style="color: #354052;">{{props.row.PosAtmListJson.length}}个（ {{props.row.PosAtmListJson.join('，')}}）</span>
        </template>
      </el-table-column>
      <el-table-column label="网点编号" prop="Code"></el-table-column>
      <el-table-column label="网点类型">
        <template scope="props">{{props.row.PosType | PosType}}</template>
      </el-table-column>
      <el-table-column label="设备类型">
        <template scope="props">{{props.row.PosDeviceType | PosDeviceType}}</template>
      </el-table-column>
      <el-table-column label="网点地址" prop="StreetAddress"></el-table-column>
      <el-table-column label="操作">
        <template scope="props">
          <el-button type="text" @click="handleOpenDialog(props.row)">编辑</el-button>
          <el-button class="danger" type="text" @click="handleRemoveItem(props.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <point-dialog name="point" :Banks="Banks" :show.sync="PointDialog.show" :title="PointDialog.Form.Id ? '编辑网点':'新增网点'" :form="PointDialog.Form" @confirm="handlePointConfirm"></point-dialog>
  </div>
</template>

<script>
import o from '@/odata'
import PointDialog from './PointDialog'
export default {
  data() {
    return {
      Search: {
        PosType: '',
        PosDeviceType: '',
        Code: '',
        Place: [],
        AtmCode: '',
      },
      PointDialog: {
        show: false,
        Form: {},
      },
      Points: [],
      Provinces: [],
      loading: true,
      Banks: [],
    }
  },
  methods: {
    handleItemChange(val) {
      const Province = this.Provinces.find((province) => province.Id === val[0])
      // let City
      // if (val[1]) {
      //   City = Province.children.find((city) => city.Id === val[1])
      // }
      if (Province.children.length === 0) {
        o('City').filter(`Province/Id eq ${val}`).get().then(({ data }) => {
          this.$set(Province, 'children', data)
        })
      // } else if (City && City.children.length === 0) {
      //   o('County').filter(`City/Id eq ${val[1]}`).get().then(({ data }) => {
      //     this.$set(City, 'children', data)
      //   })
      }
    },
    handleOpenDialog(Point) {
      this.PointDialog.Form = Object.assign({}, Point)
      // this.PointDialog.Form.PosAtmListJson = JSON.parse(Point.PosAtmListJson)
      this.PointDialog.show = true
    },
    handleRemoveItem(Point) {
      this.$confirm('即将删除网点，请慎重操作！', '删除网点', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        o(`Partner(${Point.Id})`).remove().save()
        .then(() => {
          this.$message.success('删除成功')
          this.getPoint()
        })
      }).catch(() => { })
    },
    handlePointConfirm(Point) {
      const form = Object.assign({}, Point, {
        PosAtmListJson: JSON.stringify(Point.PosAtmListJson),
        PosAtmQuantity: Point.PosAtmListJson.length,
      })
      let promise
      if (Point.Id) {
        promise = o(`Partner(${Point.Id})`).patch(form).save()
      } else {
        promise = o(`Partner`).post(form).save()
      }
      promise.then(() => {
        this.getPoint()
        this.$message.success('保存成功')
        this.PointDialog.show = false
      }).catch((error) => {
        this.$alert(error.message)
      })
    },
    getBank() {
      const Query = o('Bank')
      Query.get().then(({ data }) => {
        this.Banks = data
        console.log('服务银行', data)
      })
    },
    getPoint() {
      this.loading = true
      const Query = o('Partner')
      let filters = []
      if (this.Search.PosType) {
        filters.push(`PosType eq ${this.Search.PosType}`)
      }
      if (this.Search.PosDeviceType) {
        filters.push(`PosDeviceType eq ${this.Search.PosDeviceType}`)
      }
      if (this.Search.Code) {
        filters.push(`contains(Code, '${this.Search.Code}')`)
      }
      if (this.Search.Place.length > 0) {
        const ProvinceId = this.Search.Place[0]
        const CityId = this.Search.Place[1]
        const Province = this.Provinces.find(province => province.Id === ProvinceId)
        const City = Province.children.find(city => city.Id === CityId)
        filters.push(`(ProvinceId eq ${Province.Id} and CityId eq ${City.Id} )`)
      }
      if (this.Search.AtmCode) {
        filters.push(`contains(PosAtmListJson, '${this.Search.AtmCode}')`)
      }
      filters.push('IsPointOfSale eq true')
      Query.filter(filters.join(' and '))
      .expand('Province')
      .expand('City')
      .expand('County')
      .get().then(({data}) => {
        this.Points = data.map(item => {
          if (item.Province && item.City && item.County) {
            item.StreetAddress = item.Province.Name + item.City.Name + item.County.Name + item.Street
          }
          item.PosAtmListJson = JSON.parse(item.PosAtmListJson || '[]')
          return item
        })
        console.log(this.Points)
        this.loading = false
      })
    },
    getProvinces() {
      o('Province').get().then(({ data }) => {
        this.Provinces = data.map(province => {
          province.children = []
          return province
        })
      })
    },
  },
  created() {
    this.getPoint()
    this.getBank()
    this.getProvinces()
  },
  components: {
    PointDialog,
  },
}
</script>

<style lang="less" scoped>
.item-input {
  width: 260px;
}
.page-title2{font-size: 18px;padding-bottom: 15px;}
.danger {
  color: #ff4949;
}
.form-title {
  color: #475669;
  padding-left: 54px;
  font-weight: bold;
  font-size: 18px;
}
</style>

<style lang="less">
.customer-point .el-table__expanded-cell{
  padding: 12px 0 12px 70px;
}
</style>




// WEBPACK FOOTER //
// CustomerPointModule.vue?5a3c072e